"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/applyDecoratedDescriptor"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/weak-map"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));
var _localforage = _interopRequireDefault(require("localforage"));
var _common = require("@webex/common");
var _webexCore = require("@webex/webex-core");
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

/* eslint-env browser */

var namespaces = new _weakMap.default();
var loggers = new _weakMap.default();

/**
 * IndexedDB adapter for webex-core storage layer
 */
var StorageAdapterLocalForage = /*#__PURE__*/function () {
  /**
   * @constructs {StorageAdapterLocalForage}
   * @param {string} basekey localforage key under which
   * all namespaces will be stored
   */
  function StorageAdapterLocalForage() {
    var _dec, _dec2, _class;
    (0, _classCallCheck2.default)(this, StorageAdapterLocalForage);
    /**
     * localforage binding
     */
    this.Bound = (_dec = (0, _common.oneFlight)({
      keyFactory: function keyFactory(key) {
        return key;
      }
    }), _dec2 = (0, _common.oneFlight)({
      keyFactory: function keyFactory(key) {
        return key;
      }
    }), (_class = /*#__PURE__*/function () {
      /**
       * @constructs {Bound}
       * @param {string} namespace
       * @param {Object} options
       */
      function _class(namespace, options) {
        (0, _classCallCheck2.default)(this, _class);
        namespaces.set(this, namespace);
        loggers.set(this, options.logger);
      }

      /**
       * Clears the localforage
       * @param {string} key
       * @returns {Promise}
       */
      (0, _createClass2.default)(_class, [{
        key: "clear",
        value: function clear() {
          loggers.get(this).debug('storage-adapter-local-forage: clearing localforage');
          return _promise.default.resolve(_localforage.default.clear());
        }
      }, {
        key: "del",
        value: function del(key) {
          var key_ = "".concat(namespaces.get(this), "/").concat(key);
          loggers.get(this).debug("storage-adapter-local-forage: deleting `".concat(key_, "`"));
          return _localforage.default.removeItem(key_);
        }
      }, {
        key: "get",
        value: function get(key) {
          var key_ = "".concat(namespaces.get(this), "/").concat(key);
          loggers.get(this).debug("storage-adapter-local-forage: reading `".concat(key_, "`"));
          return _localforage.default.getItem(key_).then(function (value) {
            // if the key does not exist, getItem() will return null
            if (value === null) {
              // If we got null, we need to check if it's because the key
              // doesn't exist or because it has a saved value of null.
              return _localforage.default.keys().then(function (keys) {
                if (keys.includes(key_)) {
                  return _promise.default.resolve(value);
                }
                return _promise.default.reject(new _webexCore.NotFoundError("No value found for ".concat(key_)));
              });
            }

            //  even if undefined is saved, null will be returned by getItem()
            return _promise.default.resolve(value);
          });
        }

        /**
         * Stores the specified value at the specified key.
         * If key is undefined, removes the specified key.
         * @param {string} key
         * @param {mixed} value
         * @returns {Promise}
         */
      }, {
        key: "put",
        value: function put(key, value) {
          if (typeof value === 'undefined') {
            return this.del(key);
          }
          var key_ = "".concat(namespaces.get(this), "/").concat(key);
          loggers.get(this).debug("storage-adapter-local-forage: writing `".concat(key_, "`"));
          return _localforage.default.setItem(key_, value);
        }
      }]);
      return _class;
    }(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "del", [_dec], (0, _getOwnPropertyDescriptor.default)(_class.prototype, "del"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "get", [_dec2], (0, _getOwnPropertyDescriptor.default)(_class.prototype, "get"), _class.prototype)), _class));
  }

  /**
   * Returns an adapter bound to the specified namespace
   * @param {string} namespace
   * @param {Object} options
   * @returns {Promise<Bound>}
   */
  (0, _createClass2.default)(StorageAdapterLocalForage, [{
    key: "bind",
    value: function bind(namespace, options) {
      options = options || {};
      if (!namespace) {
        return _promise.default.reject(new Error('`namespace` is required'));
      }
      if (!options.logger) {
        return _promise.default.reject(new Error('`options.logger` is required'));
      }
      options.logger.info('storage-adapter-local-forage: returning binding');
      return _promise.default.resolve(new this.Bound(namespace, options));
    }
  }]);
  return StorageAdapterLocalForage;
}();
exports.default = StorageAdapterLocalForage;
//# sourceMappingURL=index.js.map
